import $ from 'jquery'
import {register} from '@shopify/theme-sections'
import '../../styles/components/theme-footer.scss'

export default register(`theme-footer`, {
    onLoad() {
        const searchTrigger = document.querySelector(`[data-trigger-search]`)
        if (searchTrigger) {
            searchTrigger.addEventListener(`click`, e => {
                e.preventDefault()
                document.querySelector(`[data-target="#SearchContainer"]`).click()
            })
        }
        
        // If is the Cart Template, Collection Template or PDP Template
        let template
        const body = $(`body`)
        if (body.hasClass(`template-cart`)) {
            template = `cart`
        } else if (body.hasClass(`template-product`)) {
            template = `pdp`
        } else if (body.hasClass(`template-collection`)) {
            template = `collections`
        } else if (body.hasClass(`page-new-equipment`)) {
            template = `new-equipment`
        }
    }
})
